<template>
  <Transition name="slide-fade">
    <div v-if="!accepted" id="cookies">
      <div class="container">
        <div class="d-flex">
          <img
            src="@/assets/images/logoprosegurBlanco.svg"
            class="me-3 mb-auto"
            alt="Prosegur Cash"
            width="30"
            height="30"
          />
          <div>
            <i18n-t keypath="global.cookiesPolicy.text" tag="p" scope="global">
              <template #url>
                <a :href="sanitizedUrl" target="_blank" rel="noopener noreferrer">
                  {{ t('global.cookiesPolicy.linkText') }}
                </a>
              </template>
            </i18n-t>

            <button class="btn btn-outline-primary rounded-pill" @click="acceptCookies">
              {{ t('button.acceptCookies') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { sanitizeUrl } from '@braintree/sanitize-url'

const { t } = useI18n()

const accepted = ref(localStorage.getItem('acceptCookies') === 'true')

const sanitizedUrl = computed(() => sanitizeUrl(t('global.cookiesPolicy.link') as string))

function acceptCookies() {
  localStorage.setItem('acceptCookies', 'true')
  accepted.value = true
}
</script>

<style scoped>
#cookies {
  position: fixed;
  background-color: #211f1f;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 1rem 0;
  z-index: 999;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
</style>
